import React, { useEffect } from "react";
import {
  CCol,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from '@coreui/react'
import { useState } from 'react'
import { loadingState } from 'src/atom/LoadingState'
import { useRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import 'reactjs-popup/dist/index.css'
import { createlabel, getLabels, deleteLabel } from 'src/services/Tickets/StudentTicketService'
import Confirmation from 'src/components/Confirmation'
import Pagination from 'src/components/Paginator'
import { alertMessageState } from 'src/atom/LoadingState'

const Labels = () => {
  const courseObj = {
    name: "",
  };
  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState(courseObj);
  const [validationErrors, setValidationErrors] = useState({
    name: "",
  });
  const [, enableLoader] = useRecoilState(loadingState);
  const [, setIsSubmitted] = useState(false);
  const [, setLoading] = useState(false);
  const [, setAlertMessage] = useRecoilState(alertMessageState);
  const [label, setLabel] = useState([]);
  const [ticketId, setTicketId] = useState(null);
  const [warningMessage, setWarningMessage] = useState("");

  const validateForm = () => {
    let errors = {};
    let isValid = true;
    if (!formData.name) {
      errors.name = "Please provide Label Name";
      isValid = false;
    }
    setValidationErrors(errors);
    return isValid;
  };

  const handleButtonClick = () => {
    navigate("/adminHelpDesk");
  };

  const getAllLabels = async () => {
    enableLoader(true);
    var getLabelss = async () => {
      enableLoader(false);
      var response = await getLabels({
        pageNumber: pagination.currentPage,
        search: pagination.search,
        pageSize: pagination.size,
      });
      if (response.success) {
        setLabel(response.body.labels);
        setPagination((prevValue) => ({
          ...prevValue,
          totalItems: response.body.totalElement,
          totalPages: Math.ceil(response.body.totalElement / pagination.size),
        }));
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    getLabelss();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const isValid = validateForm();
    if (isValid) {
      enableLoader(true);
      setValidationErrors({});
      setLoading(true);
      const response = await createlabel(formData);

      if (response.success) {
        setFormData({});
        getAllLabels();
        setVisible(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
      enableLoader(false);
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setTicketId(id);
    setWarningMessage("Are you sure you want to delete this label");
  };

  const navigate = useNavigate();
  const handleView = (id) => {
    setTicketId(id);
    navigate("/label-Listing", { state: { id } });
  };

  const deleteTemplateLabel = async () => {
    enableLoader(true);
    var deleteLabels = async () => {
      var response = await deleteLabel(ticketId);
      if (response.success) {
        getAllLabels();
        enableLoader(false);
        setTicketId(null);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    deleteLabels();
  };

  const mapToCollegeObj = (tickets) => {
    return {
      id: tickets.id,
      name: tickets.name,
    };
  };

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    next: "",
    prev: "",
    size: 10,
    search: "",
  });

  const nextPage = (event) => {
    setPagination((prevValue) => ({
      ...prevValue,
      currentPage: event,
    }));
  };

  useEffect(() => {
    getAllLabels();
  }, [pagination.currentPage, pagination.size]);

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Add labels</span>
            <div className="d-flex justify-content-end">
              <CButton
                style={{ marginRight: "10px" }}
                onClick={() => {
                  handleButtonClick();
                }}
              >
                Back
              </CButton>
              <CButton
                onClick={() => {
                  setVisible(!visible);
                  setFormData(courseObj);
                }}
              >
                + Add Label
              </CButton>
            </div>
          </div>
        </div>
        <div className="card-body">
          <CCol xs={12}>
            <CTable striped bordered>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">S.No</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Label Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {label?.length !== 0 ? (
                  label?.map((tickets, index) => (
                    <CTableRow key={index}>
                      <CTableHeaderCell scope="row">
                        {index + 1}
                      </CTableHeaderCell>
                      <CTableDataCell> {tickets.name || "N/A"}</CTableDataCell>

                      <CTableDataCell className="d-flex flex-wrap justify-content-start">
                        <button
                          className="btn btn-primary btn-sm mb-2 me-2"
                          onClick={() => handleView(tickets.id)}
                        >
                          View
                        </button>
                        <button
                          className="btn btn-info btn-sm mb-2 me-2"
                          onClick={() => {
                            setVisible(!visible);
                            setFormData(mapToCollegeObj(tickets));
                          }}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-primary btn-sm mb-2"
                          onClick={() => handleDelete(tickets.id)}
                        >
                          Delete
                        </button>
                      </CTableDataCell>
                    </CTableRow>
                  ))
                ) : (
                  <CTableRow>
                    <CTableDataCell colSpan={6}>No Labels Found</CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
          </CCol>
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <Pagination
                pagination={pagination}
                range={3}
                nextPage={nextPage}
                setPagination={setPagination}
              />
            </div>
          </div>
        </div>
      </div>
      <CModal
        scrollable
        visible={visible}
        onClose={() => setVisible(false)}
        size="lg"
      >
        <CModalHeader>
          <CModalTitle> Labels </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="container mt-4">
            <form onSubmit={handleSubmit}>
              <div className="row mb-2">
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="name">Label Name</label>
                    <input
                      type="text"
                      className={`form-control ${
                        validationErrors.name ? "is-invalid" : ""
                      }`}
                      id="name"
                      placeholder="Enter Label Name"
                      name="name"
                      value={formData?.name}
                      onChange={handleInputChange}
                    />
                    {validationErrors.name && (
                      <div className="invalid-feedback">
                        {validationErrors.name}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <button type="submit" className="btn btn-success text-white">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </CModalBody>
      </CModal>
      <Confirmation
        onCancel={() => {
          setWarningMessage("");
        }}
        onContinue={() => {
          deleteTemplateLabel();
          setWarningMessage("");
        }}
        warning={warningMessage}
      />
    </>
  );
};

export default Labels;
